import React, { useState, useEffect } from 'react';
import defaultImg from '../../../../assets/images/default-organization.png';
import PurpleLoadingSpinner from '../../../../assets/images/loading-spinner-purple.svg';
import { getOrganization } from '../../../api/organizationsAPI';
import { CLOUDINARY_DIR } from '../../utils/contants';

/**
 * A recommended organization card
 * @param orgData the organization data to use
 */
export const RecommendedOrganizationCard = ({ orgData }) => {
	const [imageSrc, setImageSrc] = useState(null);
	const [isImgFetching, setImgFetching] = useState(false);

	const redirectToRecommendedOrganization = () => {
		window.open(orgData.id, '_blank');
	};

	useEffect(() => {
		let isMounted = true; // Add a flag to check if the component is mounted

		async function getMissingLogo() {
			setImgFetching(true);
			const { data } = await getOrganization(orgData.id);

			let logoFromAssetUrl =
				data?.assets && data?.assets?.length > 0 && data?.assets[0].url;
			let logoFromAssetPath =
				data?.assets &&
				data?.assets?.length > 0 &&
				data?.assets[0].path;

			if (isMounted) {
				// Only update the state if the component is still mounted
				if (logoFromAssetUrl) {
					setImageSrc(logoFromAssetUrl);
				} else if (logoFromAssetPath) {
					setImageSrc(CLOUDINARY_DIR + logoFromAssetPath);
				} else {
					setImageSrc(defaultImg);
				}
			}
			setImgFetching(false);
		}

		if (orgData.logo?.path) {
			setImageSrc(
				`https://res.cloudinary.com/sponsor-circle/image/upload/${orgData.logo?.path}`
			);
		} else if (orgData.logo?.url) {
			setImageSrc(orgData.logo?.url);
		} else {
			getMissingLogo();
		}

		return () => {
			isMounted = false; // Set the flag to false when the component unmounts
		};
	}, [orgData]);

	return (
		<div
			className="recommended-organization-card"
			onClick={redirectToRecommendedOrganization}
		>
			<div className="org-logo-outer-container">
				<div className="org-logo-container">
					<img
						src={isImgFetching ? PurpleLoadingSpinner : imageSrc}
						alt={`${orgData?.legal_name} Logo`}
						className="org-logo org-logo-fit org-logo-recommendation"
					/>
				</div>
			</div>
			<div className="org-description-outer-container">
				<div className="org-description-container">
					<h6 className="organization-name">{orgData.legal_name}</h6>
					<p className="organization-location">
						{orgData.city + ', ' + orgData.country}
					</p>
				</div>
			</div>
		</div>
	);
};
